// Source: app/scripts/controllers/help.js
/**
 * Created by stefan on 24.01.2020
 */



Auction.controller('HelpController', [
  '$scope',
  '$filter',
  '$modal',
  'toaster',
  'Lot',
  '$window',
  '$timeout',
  function ($scope, $timeout, $modal, toaster, Lot) {

    // $scope.register_help = false;
    // $scope.general_help = false;
    // $scope.forgotten_password_help = false;
    // $scope.auction_help = false;
    // $scope.auction_registration_help = false;
    // $scope.auction_bidding_help = false;
    $scope.$on('refreshDepartmentTable', function (event, data) {
      console.log('DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD');
      if(data != null){
        $scope.selectTab(1);
      }
    });


    $scope.selectTabTest = function(number){
      $scope.$emit('refreshDepartmentTable', number);

    };


    $scope.selectTab = function (number) {
      console.log("vlaga");
      if (number == 1){
        console.log("vlaga 1");
        $scope.general_help = true;
        $scope.register_help = true;
        $scope.forgotten_password_help = false;
        $scope.forgotten_username_help = false;
        $scope.auction_help = false;
        $scope.auction_registration_help = false;
        $scope.auction_bidding_help = false;
        $scope.number = 1;

      }
      if (number == 2){
        console.log("vlaga 2");
        $scope.general_help = true;
        $scope.register_help = false;
        $scope.forgotten_password_help = true;
        $scope.forgotten_username_help = false;
        $scope.auction_help = false;
        $scope.auction_registration_help = false;
        $scope.auction_bidding_help = false;
      }
      if (number == 3){
        console.log("vlaga 3");
        $scope.general_help = false;
        $scope.register_help = false;
        $scope.forgotten_password_help = false;
        $scope.forgotten_username_help = false;
        $scope.auction_help = true;
        $scope.auction_registration_help = true;
        $scope.auction_bidding_help = false;
      }
      if (number == 4){
        console.log("vlaga 4");
        $scope.general_help = false;
        $scope.register_help = false;
        $scope.forgotten_password_help = false;
        $scope.forgotten_username_help = false;
        $scope.auction_help = true;
        $scope.auction_registration_help = false;
        $scope.auction_bidding_help = true;
      }
      if (number == 5){
        $scope.general_help = true;
        $scope.register_help = false;
        $scope.forgotten_password_help = false;
        $scope.forgotten_username_help = true;
        $scope.auction_help = false;
        $scope.auction_registration_help = false;
        $scope.auction_bidding_help = false;
        $scope.number = 1;

      }
      console.log("vlaga i tuka: ",$scope.general_help);
      console.log("vlaga i tuka: ",$scope.register_help);
    };







  }
]);

